import { CasinoPlayDTO } from '@arland-bmnext/webapps-api-data'
import { faClose } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { motion } from 'framer-motion'
import useTranslation from 'next-translate/useTranslation'
import React, { useEffect, useState } from 'react'
import { SlideBottomInOut } from '../../animations/common'
import Tag from '../core/Tag'
import Logo from '../layout/Logo'
import { ContainedButton } from '../core/Button'
import Link from 'next/link'

export const CasinoGameFrame = ({
  gamingSession,
  onStopCasinoGame,
  isDemoMode,
}: {
  gamingSession: CasinoPlayDTO
  onStopCasinoGame: () => void
  isDemoMode: boolean
}) => {
  const [startUrl, setStartUrl] = useState(null)

  useEffect(() => {
    if (gamingSession.providerIdentifier === 'th') {
      const [params, vars] = getTomHornParams()
      const url = buildTomHornUrl(params, vars)
      setStartUrl(url)
    } else {
      if (gamingSession.link) setStartUrl(gamingSession.link)
    }
  }, [gamingSession])

  const getTomHornParams = () => {
    const vars = {}
    const params = {}
    for (var key in gamingSession.providerParams) {
      if (key.indexOf('var:') == 0) {
        let value = gamingSession.providerParams[key]
        if (key == 'var:auth') {
          if (value.indexOf(';') > -1) {
            value = encodeURIComponent(value)
          }
        }
        vars[key.substring(4)] = value
      } else if (key.indexOf('param:') == 0) {
        params[key.substring(6)] = gamingSession.providerParams[key]
      }
    }
    return [params, vars]
  }

  const buildTomHornUrl = (params, vars) => {
    var url = params.base + vars.gameKey + '/' + vars.gameVersion + '/indexIC.html?'
    for (var key in vars) {
      url += key + '=' + vars[key] + '&'
    }
    return url
  }

  return (
    <motion.div
      className="casino-game-frame fixed top-0 left-0 w-screen h-[var(--doc-height)] bg-black bg-opacity-80 z-50"
      variants={SlideBottomInOut}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <CasinoGameFrameHeader
        onStopCasinoGame={onStopCasinoGame}
        isDemoMode={isDemoMode}
        casinoGameName={gamingSession?.competitionName}
      />
      {startUrl && <object className="casino-game-frame-game w-full h-[calc(100%-52px)]" data={startUrl}></object>}
    </motion.div>
  )
}

const CasinoGameFrameHeader = ({ isDemoMode, onStopCasinoGame, casinoGameName }) => {
  const { t } = useTranslation('casino')

  return (
    <div className="casino-game-frame-header flex justify-between items-center space-x-2 h-[52px] px-4 bg-header text-headerContrast">
      <div className="casino-game-frame-header-logo flex shrink-0 items-center cursor-pointer">
        <Logo backgroundColorVariableName="--header" height="32px" animate={false} onClick={onStopCasinoGame} />
      </div>
      <div
        className="casino-game-frame-header-actions flex justify-center items-center h-full space-x-4 cursor-pointer overflow-hidden"
        onClick={onStopCasinoGame}
      >
        <h2 className="casino-game-frame-header-actions-name font-sm font-semibold overflow-hidden overflow-ellipsis whitespace-nowrap">
          {casinoGameName}
        </h2>
        {isDemoMode ? (
          <Tag className="casino-game-frame-header-demo" label={t('Casino.useDemoMode.title')} />
        ) : (
          <Link href={'/payment/deposit'}>
            <ContainedButton className="casino-game-frame-header-deposit-button !px-2 !py-[6px]" rounded>
              {t('common:Header.deposit')}
            </ContainedButton>
          </Link>
        )}
        <FontAwesomeIcon className="casino-game-frame-header-action-close text-xl" icon={faClose} />
      </div>
    </div>
  )
}
